import moment from 'moment'

const textColor =  '#555555'
const nameTextSize = '20'
const headerTitleFont = '15'
const headerContentFont = '15'
const legendFont = '12'
const chartHeader = '20'

const nameColor = '#0072CE'
const headerTitleColor = '#555555'
const headerTextColor = '#555555'
const headerLine = '#cccccc'
const populationColor = 'rgb(0, 227, 150)'
const riskColor = 'rgb(0, 143, 251)'
const xmlns = "http://www.w3.org/2000/svg";
const fontFamily = 'Helvetica, Arial, sans-serif'

const prepareForExport = async (breast_risk_table, ovarian_risk_table, colon_risk_table, uterine_endometrial_risk_table,
    pancreatic_risk_table, melanoma_risk_table, mutation_risk_table, mutation_risk_table_2, boadicea_tab_content_breast,
    boadicea_tab_content_ovarian, claus_tab_content, gail_tab_content, tyrer_cuzick_tab_content, brcapro_tab_content_breast,
    brcapro_tab_content_ovarian, mmrpro_tab_content_colon, mmrpro_tab_content_uterine_endometrial, pancpro_tab_content,
    melapro_tab_content) => {
    // await formatTable(breast_risk_table);
    // await formatTable(ovarian_risk_table);
    // await formatTable(colon_risk_table);
    // await formatTable(uterine_endometrial_risk_table);
    // await formatTable(pancreatic_risk_table);
    // await formatTable(melanoma_risk_table);
    // await formatTable(mutation_risk_table);
    // await formatTable(mutation_risk_table_2);

    await formatGraph(boadicea_tab_content_breast);
    await formatGraph(boadicea_tab_content_ovarian);
    await formatGraph(claus_tab_content);
    await formatGraph(gail_tab_content);
    await formatGraph(tyrer_cuzick_tab_content);
    await formatGraph(brcapro_tab_content_breast);
    await formatGraph(brcapro_tab_content_ovarian);
    await formatGraph(mmrpro_tab_content_colon);
    await formatGraph(mmrpro_tab_content_uterine_endometrial);
    await formatGraph(pancpro_tab_content);
    await formatGraph(melapro_tab_content);
}

const drawLabels = (doc, labels) => {
    doc.setFontSize(18);
    doc.setFont('helvetica', 'bold', undefined);
    doc.setTextColor('#0072ce');
    doc.text(labels.probandFirstName + " " + labels.probandLastName, 20, 16, {charSpace: '-0.375'});

    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold', undefined);
    doc.setTextColor('#555555');
    doc.text(20, 21, 'ID:');
    doc.setFont('helvetica', 'normal', undefined);
    doc.text(27, 21, String(labels.probandId) + String(labels.probandGender))

    if (labels.probandDob != '' && labels.probandAge != '') {
        let birthday = new Date(labels.probandDob)
        // var dd = String(birthday.getDate()).padStart(2, '0');
        // var mm = String(birthday.getMonth() + 1).padStart(2, '0'); //January is 0!
        // var yyyy = birthday.getFullYear();
        // patientDOB = mm + '/' + dd + '/' + yyyy;
    
        // this will disregard the timezone offsets and just display the DOB as it is
        birthday = new Date( birthday.getTime() + Math.abs(birthday.getTimezoneOffset()*60000) )
        birthday = moment(birthday).format(getLocaleDateString())

        doc.setFont('helvetica', 'bold', undefined);
        doc.text(20, 26, 'DOB:');
        doc.setFont('helvetica', 'normal', undefined);
        doc.text(32, 26, String(birthday))
        doc.setFont('helvetica', 'bold', undefined);
        doc.text(56, 26, 'Age:');
        doc.setFont('helvetica', 'normal', undefined);
        doc.text(67, 26, String(labels.probandAge))
    }
    else if (labels.probandDob != '' && labels.probandAge == '') {
        doc.setFont('helvetica', 'bold', undefined);
        doc.text(20, 26, 'DOB:');
        doc.setFont('helvetica', 'normal', undefined);
        doc.text(32, 26, String(labels.probandDob))
    }
    else if (labels.probandDob == '' && labels.probandAge != '') {
        doc.setFont('helvetica', 'bold', undefined);
        doc.text(20, 26, 'Age:');
        doc.setFont('helvetica', 'normal', undefined);
        doc.text(31, 26, String(labels.probandAge))
    }

    doc.text(doc.internal.pageSize.getWidth() - 52, 26, labels.today)
    doc.setFont('helvetica', 'bold', undefined);
    doc.setTextColor('#cccccc');
    doc.text(20, 28, "______________________________________________________________________")
    doc.setFont('helvetica', 'normal', undefined);
    doc.setTextColor('#555555');
}

const getIdealAspectRatio = (doc, canvas) => {
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    const widthRatio = pageWidth / canvas.clientWidth;
    const heightRatio = pageHeight / canvas.clientHeight;
    const ratio = widthRatio > heightRatio ? heightRatio : widthRatio;

    const canvasWidth = 140.7010422222222
    const canvasHeight = 69.43035971726779

    const marginX = (pageWidth - canvasWidth) / 2;
    const marginY = (pageHeight - canvasHeight) / 2;

    return {
        canvasWidth,
        canvasHeight,
        marginX,
        marginY
    };
}

const formatGraph = (canvas) => {
    canvas.style.border = 'none'
    canvas.style.width = '840px'
    canvas.style.height = '440px'
}

const formatTable = (table) => {
    table.style.background = 'none';
    let childNodes = table.childNodes

    let thead = childNodes[0];
    let tr = thead.childNodes[0]
    let tds = tr.childNodes

    for (let td of tds) {
        td.style.background = 'none';
        td.style.color = 'black';
    }


    let tbody = childNodes[1];
    let trs = tbody.childNodes

    for (let tr of trs) {
        tr.childNodes[0].style.background = 'none';
    }
}
const createString = (node) =>{
    let string = new XMLSerializer().serializeToString(node)
    return string
}
const createSvgContainer = (width, height) =>{
    const svgContainer = document.createElementNS("http://www.w3.org/2000/svg", 'svg')
    svgContainer.setAttributeNS(null, "width", 750)
    svgContainer.setAttributeNS(null, "height", 1000)
    svgContainer.setAttributeNS("http://www.w3.org/2000/xmlns/", "xmlns:xlink", "http://www.w3.org/1999/xlink");
    return svgContainer
}

const generateSvgGraph = (graph, x, y, modelRun, blueCircleLegend, greenCircleLegend) => {
    let clone = graph.cloneNode(true)
    let blueX = greenCircleLegend ? 255 : 330
    let translateNode = createGraphLocationNode(0, y)
    if(clone.firstChild.nodeName == 'foreignObject'){
        clone.firstChild.remove()
    }
    var graphTitle = createChartHeader(modelRun, x, 30, chartHeader, nameColor)

    var circ1 = document.createElementNS( xmlns,'circle');
    circ1.setAttributeNS( null, 'cx', blueX);
    circ1.setAttributeNS( null, 'cy', 247);
    circ1.setAttributeNS( null, 'r','5');
    circ1.setAttributeNS( null, 'fill', riskColor);
    
    var circ2 = document.createElementNS( xmlns,'circle');
    circ2.setAttributeNS( null, 'cx', 345);
    circ2.setAttributeNS( null, 'cy', 247);
    circ2.setAttributeNS( null, 'r','5');
    circ2.setAttributeNS( null, 'fill', populationColor);
    
    var blueLegend = document.createElementNS(xmlns, "text");
    blueLegend.setAttributeNS(null,"font-family", fontFamily);
    blueLegend.setAttributeNS(null,"x", blueX + 10);
    blueLegend.setAttributeNS(null,"y", 251);
    blueLegend.setAttributeNS(null,"font-size", legendFont);
   
    var footerNode = document.createTextNode(blueCircleLegend);
    blueLegend.appendChild(footerNode)

    var greenLegend = document.createElementNS(xmlns, "text");
    greenLegend.setAttributeNS(null,"font-family", fontFamily);
    greenLegend.setAttributeNS(null,"x", 360);
    greenLegend.setAttributeNS(null,"y", 251);
    greenLegend.setAttributeNS(null,"font-size", legendFont);
   
    var footerNode2 = document.createTextNode(greenCircleLegend);
    greenLegend.appendChild(footerNode2)

    clone.setAttribute('viewBox', "-125 -20 1300 500")
    clone.setAttribute('height', 300)
    clone.setAttribute('width', 750)
    clone.setAttribute("position", "fixed")

    translateNode.appendChild(graphTitle)
    translateNode.appendChild(clone)
    translateNode.appendChild(circ1)
    translateNode.appendChild(blueLegend)
    if(greenCircleLegend !== null){
        translateNode.appendChild(circ2)
        translateNode.appendChild(greenLegend)
    }



    return translateNode
}


const createGraphHeader = (labels) =>{

    const svgHeader = document.createElementNS("http://www.w3.org/2000/svg", 'g')


    let {probandAge, probandDob, probandFirstName, probandGender, probandId, probandLastName, today} = labels

    let nameText = probandFirstName + ' ' + probandLastName
    let idText = probandId +  probandGender

    //create Name portion of the header
    var patientConent = createHeaderNodesSVG(nameText, 54, 60, nameTextSize, nameColor)
    svgHeader.appendChild(patientConent);
  
    //Create Id for head
    const idHeader = 'ID: '
    var id = createHeaderNodesSVG(idHeader, 55, 80, headerTitleFont, headerTitleColor)
    var idContent = createHeaderContentSVG(idText, 80, 80, headerTextColor)
    svgHeader.appendChild(id)
    svgHeader.appendChild(idContent)

    //create dob for header
    const patientDOB = 'DOB: '
    var dob = createHeaderNodesSVG(patientDOB, 55 , 100, headerTitleFont, headerTitleColor)
    var dobContent = createHeaderContentSVG(probandDob, 100, 100, headerTextColor)
    svgHeader.appendChild(dob)
    svgHeader.appendChild(dobContent)

    //create Age and Dob node for header
    const patientAge = 'Age: '
    var age = createHeaderNodesSVG(patientAge, 195, 100, headerTitleFont, headerTitleColor)
    var dobAge = createHeaderContentSVG(probandAge, 233, 100, headerTextColor)
    svgHeader.appendChild(age)
    svgHeader.appendChild(dobAge)

    var dateStamp = createHeaderContentSVG(today, 580, 100, headerTextColor)
    svgHeader.appendChild(dateStamp)


    var lineNode = createHeaderLine()
    svgHeader.appendChild(lineNode)

    return svgHeader
}



const createBreastRiskTable = (results, lifeResults, settings, chartStartingX, chartStartingY, boadicea_run, claus_run, gail_run, tyrer_run, brcapro_run, risk_model_years) =>{
    const tableContainer = document.createElementNS("http://www.w3.org/2000/svg", 'g')
    let headerX = 50

    let fiveTenYear = risk_model_years
    var title = createChartHeader('Breast', headerX, chartStartingY, chartHeader, nameColor)
    chartStartingY+= 25
    
    var tableHeader = createTableHeader(chartStartingX, chartStartingY, fiveTenYear)
    chartStartingY+=10
    
    let chartLine;
    if (risk_model_years == 'both') {
        chartLine = createTableLine(425, chartStartingY)
    } else {
        chartLine = createTableLine(340, chartStartingY)
    }    
    chartStartingY+=15

    if(settings.boadicea && boadicea_run){
        let boadiceaFiveYear = results['boadicea_breast_risk_five_year_value']
        let boadiceaTenYear = results['boadicea_breast_risk_ten_year_value']
        let boadiceaLifeTime = lifeResults.boadicea.breast.lifetime
        let boadiceaRow = createTableRow('BOADICEA', boadiceaFiveYear, boadiceaTenYear, boadiceaLifeTime, chartStartingX, chartStartingY, risk_model_years)
        chartStartingY+=25
        tableContainer.appendChild(boadiceaRow)
    }

    if(settings.claus && claus_run){
        let clausFive = results['claus_breast_risk_five_year_value']
        let clausTen = results['claus_breast_risk_ten_year_value']
        let clausLifeTime = lifeResults.claus.breast.lifetime
        let clausRow = createTableRow('CLAUS', clausFive, clausTen, clausLifeTime, chartStartingX, chartStartingY, risk_model_years)
        chartStartingY+=25
        tableContainer.appendChild(clausRow)
    }
    if(settings.gail && gail_run){
        let gailFive = results['gail_breast_risk_five_year_value']
        let gailTen = results['gail_breast_risk_ten_year_value']
        let gailLifetime = lifeResults.gail.breast.lifetime
        let gailRow = createTableRow('GAIL', gailFive, gailTen, gailLifetime, chartStartingX, chartStartingY, risk_model_years)
        chartStartingY+=25
        tableContainer.appendChild(gailRow)
    }
    if(settings.tyrer_cuzick && tyrer_run){
        let tyrerFive = results['tyrer_cuzick_breast_risk_five_year_value']
        let tyrerTen = results['tyrer_cuzick_breast_risk_ten_year_value']
        let tyrerLifeTime = lifeResults.tyrer_cuzick.breast.lifetime
        let tyrerRow = createTableRow('TYRER-CUZICK', tyrerFive, tyrerTen, tyrerLifeTime, chartStartingX, chartStartingY, risk_model_years)
        chartStartingY+=25
        tableContainer.appendChild(tyrerRow)
    }
    if(settings.brcapro && brcapro_run){
        let brcaProFive = results['brcapro_breast_risk_five_year_value']
        let brcaProTen = results['brcapro_breast_risk_ten_year_value']
        let brcaProLifetime = lifeResults.brcapro.breast.lifetime
        let brcaproRow = createTableRow('BRCAPRO', brcaProFive, brcaProTen, brcaProLifetime, chartStartingX, chartStartingY, risk_model_years)
        tableContainer.appendChild(brcaproRow)
    }
    
    tableContainer.appendChild(title)
    tableContainer.appendChild(tableHeader)
    tableContainer.appendChild(chartLine)
    return {
    "tableContainer" : tableContainer,
    "yEnd" : chartStartingY
    }

}

const createOvarianTable = (results, lifeResults, settings, chartStartingX, chartStartingY, boadicea_run, brcapro_run, risk_model_years) =>{
    const tableContainer = document.createElementNS("http://www.w3.org/2000/svg", 'g')
    let headerX = 50
    let fiveTenYear = risk_model_years

    var title = createChartHeader('Ovarian', headerX, chartStartingY, chartHeader, nameColor)
    chartStartingY+= 25
    
    var tableHeader = createTableHeader(chartStartingX, chartStartingY, fiveTenYear)
    chartStartingY+=10
    
    let chartLine;
    if (risk_model_years == 'both') {
        chartLine = createTableLine(425, chartStartingY)
    } else {
        chartLine = createTableLine(340, chartStartingY)
    }
    chartStartingY+=15
   
    if(settings.boadicea && boadicea_run){
        let boadiceaFive = results["boadicea_ovarian_risk_five_year_value"]
        let boadiceaTen = results["boadicea_ovarian_risk_ten_year_value"]
        let mmrproLife = lifeResults.boadicea.ovarian.lifetime
        let mmrproRow = createTableRow('BOADICEA', boadiceaFive, boadiceaTen, mmrproLife, chartStartingX, chartStartingY, risk_model_years)
        chartStartingY+=25
        tableContainer.appendChild(mmrproRow)
    }
    if(settings.brcapro && brcapro_run){
        let brcaProFive = results['brcapro_ovarian_risk_five_year_value']
        let brcaProTen = results['brcapro_ovarian_risk_ten_year_value']
        let brcaProLifetime = lifeResults.brcapro.ovarian.lifetime
        let brcaproRow = createTableRow('BRCAPRO', brcaProFive, brcaProTen, brcaProLifetime, chartStartingX, chartStartingY, risk_model_years)
        tableContainer.appendChild(brcaproRow)
    }

    tableContainer.appendChild(title)
    tableContainer.appendChild(tableHeader)
    tableContainer.appendChild(chartLine)
    return {
    "tableContainer" : tableContainer,
    "yEnd" : chartStartingY
    }

    
}
const createColonTable = (results, lifeResults, settings, chartStartingX, chartStartingY, mmrpro_run, risk_model_years) => {
    const tableContainer = document.createElementNS("http://www.w3.org/2000/svg", 'g')
    let headerX = 50
    let fiveTenYear = risk_model_years
    var title = createChartHeader('Colon', headerX, chartStartingY, chartHeader, nameColor)
    chartStartingY+= 25
    
    var tableHeader = createTableHeader(chartStartingX, chartStartingY, fiveTenYear)
    chartStartingY+=10
    
    let chartLine;
    if (risk_model_years == 'both') {
        chartLine = createTableLine(425, chartStartingY)
    } else {
        chartLine = createTableLine(340, chartStartingY)
    }
    chartStartingY+=15

    if(settings.mmrpro && mmrpro_run){
        let mmrproFive = results['mmrpro_colon_risk_five_year_value']
        let mmrproTen = results['mmrpro_colon_risk_ten_year_value']
        let mmrproLifetime = lifeResults.mmrpro.colon.lifetime
        let mmrproRow = createTableRow('MMRPRO', mmrproFive, mmrproTen, mmrproLifetime, chartStartingX, chartStartingY, risk_model_years)
        tableContainer.appendChild(mmrproRow)
    }

    tableContainer.appendChild(title)
    tableContainer.appendChild(tableHeader)
    tableContainer.appendChild(chartLine)
    return {
    "tableContainer" : tableContainer,
    "yEnd" : chartStartingY
    }

}
const createUterineTable = (results, lifeResults, settings, chartStartingX, chartStartingY, mmrpro_run, risk_model_years) =>{
    const tableContainer = document.createElementNS("http://www.w3.org/2000/svg", 'g')
    let headerX = 50

    let fiveTenYear = risk_model_years
    var title = createChartHeader('Uterine/Endometrial', headerX, chartStartingY, chartHeader, nameColor)
    chartStartingY+= 25
    
    var tableHeader = createTableHeader(chartStartingX, chartStartingY, fiveTenYear)
    chartStartingY+=10
    
    let chartLine;
    if (risk_model_years == 'both') {
        chartLine = createTableLine(425, chartStartingY)
    } else {
        chartLine = createTableLine(340, chartStartingY)
    }
    chartStartingY+=15

    if(settings.mmrpro && mmrpro_run){
        //do we need && mmrpro_run?
        let mmrproFive = results['mmrpro_uterine_endometrial_risk_five_year_value']
        let mmrproTen = results['mmrpro_uterine_endometrial_risk_ten_year_value']
        let mmrproLifetime = lifeResults.mmrpro.uterine_endometrial.lifetime
        let mmrproRow = createTableRow('MMRPRO', mmrproFive, mmrproTen, mmrproLifetime, chartStartingX, chartStartingY, risk_model_years)
        tableContainer.appendChild(mmrproRow)
    }
    
    tableContainer.appendChild(title)
    tableContainer.appendChild(tableHeader)
    tableContainer.appendChild(chartLine)
    return {
    "tableContainer" : tableContainer,
    "yEnd" : chartStartingY
    }
}
const createPancTable = (results, lifeResults, settings, chartStartingX, chartStartingY, pancpro_run, risk_model_years) =>{
    const tableContainer = document.createElementNS("http://www.w3.org/2000/svg", 'g')
    let headerX = 50

    let fiveTenYear = risk_model_years

    var title = createChartHeader('Pancreatic', headerX, chartStartingY, chartHeader, nameColor)
    chartStartingY+= 25
    
    var tableHeader = createTableHeader(chartStartingX, chartStartingY, fiveTenYear)
    chartStartingY+=10
    
    let chartLine;
    if (risk_model_years == 'both') {
        chartLine = createTableLine(425, chartStartingY)
    } else {
        chartLine = createTableLine(340, chartStartingY)
    }
    chartStartingY+=15

    if(settings.pancpro && pancpro_run){
        let pancFive = results['pancpro_pancreatic_risk_five_year_value']
        let pancTen = results['pancpro_pancreatic_risk_ten_year_value']
        let pancLifetime = lifeResults.mmrpro.uterine_endometrial.lifetime
        let pancRow = createTableRow('PANCPRO', pancFive, pancTen, pancLifetime, chartStartingX, chartStartingY, risk_model_years)
        tableContainer.appendChild(pancRow)
    }
    
    
    tableContainer.appendChild(title)
    tableContainer.appendChild(tableHeader)
    tableContainer.appendChild(chartLine)
    return {
    "tableContainer" : tableContainer,
    "yEnd" : chartStartingY
    }
}
const createMelanomaTable = (results, lifeResults, settings, chartStartingX, chartStartingY, melapro_run, risk_model_years) =>{
    const tableContainer = document.createElementNS("http://www.w3.org/2000/svg", 'g')
    let headerX = 50
    let fiveTenYear = risk_model_years
    var title = createChartHeader('Melanoma', headerX, chartStartingY, chartHeader, nameColor)
    chartStartingY+= 25
    
    var tableHeader = createTableHeader(chartStartingX, chartStartingY, fiveTenYear)
    chartStartingY+=10
    
    let chartLine;
    if (risk_model_years == 'both') {
        chartLine = createTableLine(425, chartStartingY)
    } else {
        chartLine = createTableLine(340, chartStartingY)
    }
    chartStartingY+=15

    if(settings.melapro && melapro_run){
        let pancFive = results['melapro_melanoma_risk_five_year_value']
        let pancTen = results['melapro_melanoma_risk_ten_year_value']
        let pancLifetime = lifeResults.melapro.melanoma.lifetime
        let pancRow = createTableRow('MELAPRO', pancFive, pancTen, pancLifetime, chartStartingX, chartStartingY, risk_model_years)
        tableContainer.appendChild(pancRow)
    }

    tableContainer.appendChild(title)
    tableContainer.appendChild(tableHeader)
    tableContainer.appendChild(chartLine)
    return {
    "tableContainer" : tableContainer,
    "yEnd" : chartStartingY
    }
}

const createTableRow = (modelRun, fiveResult, tenResult, lifeTime, x, y, risk_model_years) =>{
    let fontSize = 15
    const tableHeaderContainer = document.createElementNS("http://www.w3.org/2000/svg", 'g')
    let fiveFixed = (fiveResult == null || fiveResult == 'N/A') ? 'N/A' : `${fiveResult}%`
    let tenFixed = (tenResult == null || tenResult == 'N/A') ? 'N/A' : `${tenResult}%`
    let lifeTimeFixed = (lifeTime == 'N/A' ) ? 'N/A' : `${lifeTime}%`

    let model = document.createElementNS(xmlns, "text");
    model.setAttributeNS(null, "font-family", fontFamily)
    model.setAttributeNS(null,"x", x);
    model.setAttributeNS(null,"y", y);
    model.setAttributeNS(null,"font-size", fontSize);
    model.setAttributeNS(null,"fill", textColor);


    var content = document.createTextNode(modelRun);
    model.appendChild(content)

    
    let fiveTenYear = document.createElementNS(xmlns, "text");
    fiveTenYear.setAttributeNS(null, "font-family", fontFamily)
    fiveTenYear.setAttributeNS(null,"x", x + 143);
    fiveTenYear.setAttributeNS(null,"y", y);
    fiveTenYear.setAttributeNS(null,"font-size", fontSize);
    fiveTenYear.setAttributeNS(null,"fill", textColor);

    let tenYear = document.createElementNS(xmlns, "text");
    tenYear.setAttributeNS(null, "font-family", fontFamily)
    tenYear.setAttributeNS(null,"x", x + 230);
    tenYear.setAttributeNS(null,"y", y);
    tenYear.setAttributeNS(null,"font-size", fontSize);
    tenYear.setAttributeNS(null,"fill", textColor);

    let lifetime = document.createElementNS(xmlns, "text");
    lifetime.setAttributeNS(null, "font-family", fontFamily)
    if (risk_model_years == 'both') {
        lifetime.setAttributeNS(null,"x", x + 317);
    } else {
        lifetime.setAttributeNS(null,"x", x + 230);
    }
    lifetime.setAttributeNS(null,"y", y);
    lifetime.setAttributeNS(null,"font-size", fontSize);
    lifetime.setAttributeNS(null,"fill", textColor);
    
    var content2;
    var contentTen;
    if (risk_model_years == 'ten-year') {
        content2 = document.createTextNode(tenFixed);
        fiveTenYear.appendChild(content2)
    } else if (risk_model_years == 'five-year') {
        content2 = document.createTextNode(fiveFixed);
        fiveTenYear.appendChild(content2)
    } else {
        content2 = document.createTextNode(fiveFixed);
        contentTen = document.createTextNode(tenFixed)
        fiveTenYear.appendChild(content2)
        tenYear.appendChild(contentTen)
    }
    
    var content3 = document.createTextNode(lifeTimeFixed);
    lifetime.appendChild(content3)
    

    tableHeaderContainer.appendChild(model)
    tableHeaderContainer.appendChild(fiveTenYear)
    if (risk_model_years == 'both') {
        tableHeaderContainer.appendChild(tenYear)
    }
    tableHeaderContainer.appendChild(lifetime)
    return tableHeaderContainer
}

const createFooter = (text) =>{
    let fontSize = 11

    const footerContent = document.createElementNS("http://www.w3.org/2000/svg", 'g')
    let title = 'FamGenix Risk Assessment Report'
    let riskNode = document.createElementNS(xmlns, "text");
    riskNode.setAttributeNS(null,"x", 40);
    riskNode.setAttributeNS(null,"y", 925);
    riskNode.setAttributeNS(null,"font-size", fontSize);
    riskNode.setAttributeNS(null,"fill", textColor);

    riskNode.setAttributeNS(null,"font-family", 'Arial, Helvetica, sans-serif');
    
    var footerTitle = document.createTextNode(title);
    riskNode.appendChild(footerTitle)

    let contentNode = document.createElementNS(xmlns, "text");
    contentNode.setAttributeNS(null,"x", 40);
    contentNode.setAttributeNS(null,"y", 940);
    contentNode.setAttributeNS(null,"font-size", fontSize);
    contentNode.setAttributeNS(null,"fill", textColor);

    contentNode.setAttributeNS(null,"font-family", 'Arial, Helvetica, sans-serif');
    
    var content = document.createTextNode(text);
    contentNode.appendChild(content)

    footerContent.appendChild(riskNode)
    footerContent.appendChild(contentNode)

    return footerContent

}

const createGraphLocationNode = (x, y) =>{
    const parentGTag = document.createElementNS('http://www.w3.org/2000/svg', 'g')
    parentGTag.setAttribute("transform", `translate(${x}, ${y})`)
  
    return parentGTag
}

const createHeaderNodesSVG = (headerTitle, x, y, fontSize, fontColor) =>{
    var xmlns = "http://www.w3.org/2000/svg";
  
    let titleNode = document.createElementNS(xmlns, "text");
    titleNode.setAttributeNS(null,"font-family", fontFamily);
    titleNode.setAttributeNS(null,"x", x);
    titleNode.setAttributeNS(null,"y", y);
    titleNode.setAttributeNS(null,"font-size", fontSize);
    titleNode.setAttributeNS(null,"font-weight", "bold");
    titleNode.setAttributeNS(null,"fill", fontColor);

    var title = document.createTextNode(headerTitle);
    titleNode.appendChild(title)
  
    return titleNode
  }

const createChartHeader = (headerTitle, x, y, fontSize, fontColor) =>{
    var xmlns = "http://www.w3.org/2000/svg";
  
    let titleNode = document.createElementNS(xmlns, "text");
    titleNode.setAttributeNS(null,"font-family", fontFamily);
    titleNode.setAttributeNS(null,"x", x);
    titleNode.setAttributeNS(null,"y", y);
    titleNode.setAttributeNS(null,"font-size", fontSize);
    titleNode.setAttributeNS(null,"fill", fontColor);

    var title = document.createTextNode(headerTitle);
    titleNode.appendChild(title)
  
    return titleNode
  }

const createHeaderContentSVG = (headerContent, x, y, textColor) => {
    let fontSize = 15
    var xmlns = "http://www.w3.org/2000/svg";

    let contentNode = document.createElementNS(xmlns, "text");
    contentNode.setAttributeNS(null,"x", x);
    contentNode.setAttributeNS(null,"y", y);
    contentNode.setAttributeNS(null,"font-size", fontSize);
    contentNode.setAttributeNS(null,"fill", textColor);

    contentNode.setAttributeNS(null,"font-family", fontFamily);
    
    var content = document.createTextNode(headerContent);
    contentNode.appendChild(content)

    return contentNode
  }

const createHeaderLine = () =>{
    var xmlns = "http://www.w3.org/2000/svg";

    let lineNode = document.createElementNS(xmlns, "line");
    lineNode.setAttributeNS(null,"x1", 715);
    lineNode.setAttributeNS(null,"y1", 110);
    lineNode.setAttributeNS(null,"x2", 30);
    lineNode.setAttributeNS(null,"y2", 110);
    lineNode.setAttributeNS(null,"style", `stroke:${headerLine}; stroke-width:2`);
    return lineNode
}

const createTableLine = (x, y) =>{
    var xmlns = "http://www.w3.org/2000/svg";

    let lineNode = document.createElementNS(xmlns, "line");
    lineNode.setAttributeNS(null,"x1", x);
    lineNode.setAttributeNS(null,"y1", y);
    lineNode.setAttributeNS(null,"x2", 50);
    lineNode.setAttributeNS(null,"y2", y);
    lineNode.setAttributeNS(null,"style", `stroke:${headerLine};stroke-width:2`);
    return lineNode
}

const createTableHeader = (x, y, fiveOrTenYear) =>{
    let fontSize = 14
    const tableHeaderContainer = document.createElementNS("http://www.w3.org/2000/svg", 'g')


    let model = document.createElementNS(xmlns, "text");
    model.setAttributeNS(null,"font-family", fontFamily);
    model.setAttributeNS(null,"x", x);
    model.setAttributeNS(null,"y", y);
    model.setAttributeNS(null,"font-size", fontSize);
    model.setAttributeNS(null,"font-weight", "bold");
    model.setAttributeNS(null,"fill", textColor);


    var content = document.createTextNode('Model');
    model.appendChild(content)

    
    let fiveTenYear = document.createElementNS(xmlns, "text");
    fiveTenYear.setAttributeNS(null,"font-family", fontFamily);
    fiveTenYear.setAttributeNS(null,"x", x + 140);
    fiveTenYear.setAttributeNS(null,"y", y);
    fiveTenYear.setAttributeNS(null,"font-size", fontSize);
    fiveTenYear.setAttributeNS(null,"font-weight", "bold");
    fiveTenYear.setAttributeNS(null,"fill", textColor);

    let tenYear = document.createElementNS(xmlns, "text");
    tenYear.setAttributeNS(null,"font-family", fontFamily);
    tenYear.setAttributeNS(null,"x", x + 225);
    tenYear.setAttributeNS(null,"y", y);
    tenYear.setAttributeNS(null,"font-size", fontSize);
    tenYear.setAttributeNS(null,"font-weight", "bold");
    tenYear.setAttributeNS(null,"fill", textColor);

    var content2;
    var contentTen;

    if (fiveOrTenYear == 'ten-year') {
        fiveOrTenYear = '10 Year'
        content2 = document.createTextNode(fiveOrTenYear);
        fiveTenYear.appendChild(content2)
    } else if (fiveOrTenYear == 'five-year') {
        fiveOrTenYear = '5 Year'
        content2 = document.createTextNode(fiveOrTenYear);
        fiveTenYear.appendChild(content2)
    } else {
        content2 = document.createTextNode('5 Year');
        contentTen = document.createTextNode('10 Year')
        fiveTenYear.appendChild(content2)
        tenYear.appendChild(contentTen)
    }


    
    let lifeTime = document.createElementNS(xmlns, "text");
    lifeTime.setAttributeNS(null,"font-family", fontFamily);
    if (fiveOrTenYear == 'both') {
        lifeTime.setAttributeNS(null,"x", x + 310);
    } else {
        lifeTime.setAttributeNS(null,"x", x + 225);
    }
    lifeTime.setAttributeNS(null,"y", y);
    lifeTime.setAttributeNS(null,"font-size", fontSize);
    lifeTime.setAttributeNS(null,"font-weight", "bold");
    lifeTime.setAttributeNS(null,"fill", textColor);

    var content3 = document.createTextNode('Lifetime');
    lifeTime.appendChild(content3)

    tableHeaderContainer.appendChild(model)
    tableHeaderContainer.appendChild(fiveTenYear)
    if (fiveOrTenYear == 'both') {
        tableHeaderContainer.appendChild(tenYear)
    }
    tableHeaderContainer.appendChild(lifeTime)

    return tableHeaderContainer
}


//Function for creation of mutation tables
const createMutationTable1 = (mutationValues, settings, chartStartingX, chartStartingY, boadicea_run, tyrer_cuzick_run, brcapro_run) =>{
    const tableContainer = document.createElementNS("http://www.w3.org/2000/svg", 'g')
    var tableHeader = createMutationTableHeader(chartStartingX, chartStartingY)
    chartStartingY+=10
    
    let chartLine = createMutationTableLine(chartStartingY)
    chartStartingY+=15



    if(settings.boadicea && boadicea_run){
        let brca1 =  mutationValues.boadicea.mutation_probabilities[1]['BRCA1'].percent
        let brca2 = mutationValues.boadicea.mutation_probabilities[2]['BRCA2'].percent
        let palb2 = mutationValues.boadicea.mutation_probabilities[3]['PALB2'].percent
        let atm =  mutationValues.boadicea.mutation_probabilities[5]['ATM'].percent
        let check2 =  mutationValues.boadicea.mutation_probabilities[4]['CHEK2'].percent
        let boadiceRow = createMutationRow('BOADICEA', brca1, brca2, palb2, atm, check2, chartStartingX, chartStartingY)
        tableContainer.appendChild(boadiceRow)
        chartStartingY+=23
    }

    if(settings.tyrer_cuzick && tyrer_cuzick_run){
        let brca1 =  mutationValues.tyrer_cuzick.mutation_probabilities[1]['BRCA1'].percent
        let brca2 = mutationValues.tyrer_cuzick.mutation_probabilities[2]['BRCA2'].percent
        let tyrerRow = createMutationRow('TYRER-CUZICK', brca1, brca2, 'N/A', 'N/A', 'N/A', chartStartingX, chartStartingY)
        tableContainer.appendChild(tyrerRow)
        chartStartingY+=23
    }
    if(settings.brcapro && brcapro_run){
        let brca1 =  mutationValues.brcapro.mutation_probabilities[1]['BRCA1'].percent
        let brca2 = mutationValues.brcapro.mutation_probabilities[2]['BRCA2'].percent
        let brcaRow = createMutationRow('BRCAPRO', brca1, brca2, 'N/A', 'N/A', 'N/A', chartStartingX, chartStartingY)
        tableContainer.appendChild(brcaRow)
        chartStartingY+=23
    }

    tableContainer.appendChild(tableHeader)
    tableContainer.appendChild(chartLine)
    return {
    "tableContainer" : tableContainer,
    "yEnd" : chartStartingY
    }
}

const createMutationTable2 = (mutationValues, settings, chartStartingX, chartStartingY, mmrpro_run, pancpro_run, melapro_run) =>{
    const tableContainer = document.createElementNS("http://www.w3.org/2000/svg", 'g')    
    var tableHeader = createMutationTable2Header(chartStartingX, chartStartingY)
    chartStartingY+=10
    
    let chartLine = createMutationTableLine(chartStartingY)
    chartStartingY+=15

    if(settings.mmrpro && mmrpro_run){
        let mlh1 = mutationValues.mmrpro.mutation_probabilities[1]['MLH1'].percent
        let msh2 = mutationValues.mmrpro.mutation_probabilities[2]['MSH2'].percent
        let mash6 =  mutationValues.mmrpro.mutation_probabilities[3]['MSH6'].percent
        let mmrproRow = createMutationRow('MMRPRO', 'N/A', mlh1, msh2, mash6, 'N/A', chartStartingX, chartStartingY)
        tableContainer.appendChild(mmrproRow)
        chartStartingY+=23
    }
    if(settings.pancpro && pancpro_run){
        let pancGene =  mutationValues.pancpro.mutation_probabilities[1]['pancreaticGene'].percent
        let pancRow = createMutationRow('PANCPRO', 'N/A', 'N/A', 'N/A', 'N/A', pancGene, chartStartingX, chartStartingY)
        tableContainer.appendChild(pancRow)
        chartStartingY+=23
    }

    if(settings.melapro && melapro_run){
        let p16 =  mutationValues.melapro.mutation_probabilities[1]['P16'].percent
        let melaRow = createMutationRow('MELAPRO', p16, 'N/A', 'N/A', 'N/A', 'N/A', chartStartingX, chartStartingY)
        tableContainer.appendChild(melaRow)
        chartStartingY+=23
    }

    tableContainer.appendChild(tableHeader)
    tableContainer.appendChild(chartLine)
    return {
    "tableContainer" : tableContainer,
    "yEnd" : chartStartingY
    }

}
const createMutationTableLine = (y) =>{
    var xmlns = "http://www.w3.org/2000/svg";

    let lineNode = document.createElementNS(xmlns, "line");
    lineNode.setAttributeNS(null,"x1", 700);
    lineNode.setAttributeNS(null,"y1", y);
    lineNode.setAttributeNS(null,"x2", 50);
    lineNode.setAttributeNS(null,"y2", y);
    lineNode.setAttributeNS(null,"style", `stroke:${headerLine};stroke-width:2`);
    return lineNode
}

const createMutationTable2Header = (x, y) =>{
    let fontSize = 14
    const tableHeaderContainer = document.createElementNS("http://www.w3.org/2000/svg", 'g')


    let model = document.createElementNS(xmlns, "text");
    model.setAttributeNS(null,"font-family", fontFamily);
    model.setAttributeNS(null,"x", x);
    model.setAttributeNS(null,"y", y);
    model.setAttributeNS(null,"font-size", fontSize);
    model.setAttributeNS(null,"font-weight", "bold");
    model.setAttributeNS(null,"fill", textColor);


    var content = document.createTextNode('Model');
    model.appendChild(content)


    let p16 = document.createElementNS(xmlns, "text");
    p16.setAttributeNS(null,"font-family", fontFamily);
    p16.setAttributeNS(null,"x", x + 140);
    p16.setAttributeNS(null,"y", y);
    p16.setAttributeNS(null,"font-size", fontSize);
    p16.setAttributeNS(null,"font-weight", "bold");
    p16.setAttributeNS(null,"fill", textColor);

    var content2 = document.createTextNode('P16');
    p16.appendChild(content2)


    let mlh1 = document.createElementNS(xmlns, "text");
    mlh1.setAttributeNS(null,"font-family", fontFamily);
    mlh1.setAttributeNS(null,"x", x + 225);
    mlh1.setAttributeNS(null,"y", y);
    mlh1.setAttributeNS(null,"font-size", fontSize);
    mlh1.setAttributeNS(null,"font-weight", "bold");
    mlh1.setAttributeNS(null,"fill", textColor);

    var content3 = document.createTextNode('MLH1');
    mlh1.appendChild(content3)

    let msh2 = document.createElementNS(xmlns, "text");
    msh2.setAttributeNS(null,"font-family", fontFamily);
    msh2.setAttributeNS(null,"x", x + 325);
    msh2.setAttributeNS(null,"y", y);
    msh2.setAttributeNS(null,"font-size", fontSize);
    msh2.setAttributeNS(null,"font-weight", "bold");
    msh2.setAttributeNS(null,"fill", textColor);

    var content4 = document.createTextNode('MSH2');
    msh2.appendChild(content4)


    let msh6 = document.createElementNS(xmlns, "text");
    msh6.setAttributeNS(null,"font-family", fontFamily);
    msh6.setAttributeNS(null,"x", x + 425);
    msh6.setAttributeNS(null,"y", y);
    msh6.setAttributeNS(null,"font-size", fontSize);
    msh6.setAttributeNS(null,"font-weight", "bold");
    msh6.setAttributeNS(null,"fill", textColor);

    var content5 = document.createTextNode('MSH6');
    msh6.appendChild(content5)

    let pancGene = document.createElementNS(xmlns, "text");
    pancGene.setAttributeNS(null,"font-family", fontFamily);
    pancGene.setAttributeNS(null,"x", x + 525);
    pancGene.setAttributeNS(null,"y", y);
    pancGene.setAttributeNS(null,"font-size", fontSize);
    pancGene.setAttributeNS(null,"font-weight", "bold");
    pancGene.setAttributeNS(null,"fill", textColor);

    var content6 = document.createTextNode('PANC GENE');
    pancGene.appendChild(content6)

    tableHeaderContainer.appendChild(model)
    tableHeaderContainer.appendChild(p16)
    tableHeaderContainer.appendChild(mlh1)
    tableHeaderContainer.appendChild(msh2)
    tableHeaderContainer.appendChild(msh6)
    tableHeaderContainer.appendChild(pancGene)

    return tableHeaderContainer
}


const createMutationTableHeader = (x, y) =>{
    let fontSize = 14
    const tableHeaderContainer = document.createElementNS("http://www.w3.org/2000/svg", 'g')


    let model = document.createElementNS(xmlns, "text");
    model.setAttributeNS(null,"font-family", fontFamily);
    model.setAttributeNS(null,"x", x);
    model.setAttributeNS(null,"y", y);
    model.setAttributeNS(null,"font-size", fontSize);
    model.setAttributeNS(null,"font-weight", "bold");
    model.setAttributeNS(null,"fill", textColor);


    var content = document.createTextNode('Model');
    model.appendChild(content)


    let brca1 = document.createElementNS(xmlns, "text");
    brca1.setAttributeNS(null,"font-family", fontFamily);
    brca1.setAttributeNS(null,"x", x + 140);
    brca1.setAttributeNS(null,"y", y);
    brca1.setAttributeNS(null,"font-size", fontSize);
    brca1.setAttributeNS(null,"font-weight", "bold");
    brca1.setAttributeNS(null,"fill", textColor);

    var content2 = document.createTextNode('BRCA1');
    brca1.appendChild(content2)


    let brca2 = document.createElementNS(xmlns, "text");
    brca2.setAttributeNS(null,"font-family", fontFamily);
    brca2.setAttributeNS(null,"x", x + 225);
    brca2.setAttributeNS(null,"y", y);
    brca2.setAttributeNS(null,"font-size", fontSize);
    brca2.setAttributeNS(null,"font-weight", "bold");
    brca2.setAttributeNS(null,"fill", textColor);

    var content3 = document.createTextNode('BRCA2');
    brca2.appendChild(content3)

    let palb2 = document.createElementNS(xmlns, "text");
    palb2.setAttributeNS(null,"font-family", fontFamily);
    palb2.setAttributeNS(null,"x", x + 325);
    palb2.setAttributeNS(null,"y", y);
    palb2.setAttributeNS(null,"font-size", fontSize);
    palb2.setAttributeNS(null,"font-weight", "bold");
    palb2.setAttributeNS(null,"fill", textColor);

    var content4 = document.createTextNode('PALB2');
    palb2.appendChild(content4)


    let atm = document.createElementNS(xmlns, "text");
    atm.setAttributeNS(null,"font-family", fontFamily);
    atm.setAttributeNS(null,"x", x + 425);
    atm.setAttributeNS(null,"y", y);
    atm.setAttributeNS(null,"font-size", fontSize);
    atm.setAttributeNS(null,"font-weight", "bold");
    atm.setAttributeNS(null,"fill", textColor);

    var content5 = document.createTextNode('ATM');
    atm.appendChild(content5)

    let check2 = document.createElementNS(xmlns, "text");
    check2.setAttributeNS(null,"font-family", fontFamily);
    check2.setAttributeNS(null,"x", x + 525);
    check2.setAttributeNS(null,"y", y);
    check2.setAttributeNS(null,"font-size", fontSize);
    check2.setAttributeNS(null,"font-weight", "bold");
    check2.setAttributeNS(null,"fill", textColor);

    var content6 = document.createTextNode('CHEK2');
    check2.appendChild(content6)

    tableHeaderContainer.appendChild(model)
    tableHeaderContainer.appendChild(brca1)
    tableHeaderContainer.appendChild(brca2)
    tableHeaderContainer.appendChild(palb2)
    tableHeaderContainer.appendChild(atm)
    tableHeaderContainer.appendChild(check2)

    return tableHeaderContainer
}


const createMutationRow = (modelRun, col1, col2, col3, col4, col5, x, y) =>{
    let fontSize = 15
    const tableHeaderContainer = document.createElementNS("http://www.w3.org/2000/svg", 'g')
    let val1 = (col1 == 'N/A') ? 'N/A' : `${col1}%`
    let val2 = (col2 == 'N/A') ? 'N/A' : `${col2}%`
    let val3 = (col3 == 'N/A') ? 'N/A' : `${col3}%`
    let val4 = (col4 == 'N/A') ? 'N/A' : `${col4}%`
    let val5 = (col5 == 'N/A') ? 'N/A' : `${col5}%`

    let model = document.createElementNS(xmlns, "text");
    model.setAttributeNS(null,"font-family", fontFamily);

    model.setAttributeNS(null,"x", x);
    model.setAttributeNS(null,"y", y);
    model.setAttributeNS(null,"font-size", fontSize);
    model.setAttributeNS(null,"fill", textColor);

    var modelContent = document.createTextNode(modelRun);
    model.appendChild(modelContent)

    
    let column1 = document.createElementNS(xmlns, "text");
    column1.setAttributeNS(null,"font-family", fontFamily);
    column1.setAttributeNS(null,"x", x + 143);
    column1.setAttributeNS(null,"y", y);
    column1.setAttributeNS(null,"font-size", fontSize);
    column1.setAttributeNS(null,"fill", textColor);

    var content = document.createTextNode(`${val1}`);
    column1.appendChild(content)

    
    let column2 = document.createElementNS(xmlns, "text");
    column2.setAttributeNS(null,"font-family", fontFamily);
    column2.setAttributeNS(null,"x", x + 230);
    column2.setAttributeNS(null,"y", y);
    column2.setAttributeNS(null,"font-size", fontSize);
    column2.setAttributeNS(null,"fill", textColor);

    var content3 = document.createTextNode(`${val2}`);
    column2.appendChild(content3)


    let column3 = document.createElementNS(xmlns, "text");
    column3.setAttributeNS(null,"font-family", fontFamily);
    column3.setAttributeNS(null,"x", x + 330);
    column3.setAttributeNS(null,"y", y);
    column3.setAttributeNS(null,"font-size", fontSize);
    column3.setAttributeNS(null,"fill", textColor);

    var content3 = document.createTextNode(`${val3}`);
    column3.appendChild(content3)

    
    let column4 = document.createElementNS(xmlns, "text");
    column4.setAttributeNS(null,"font-family", fontFamily);
    column4.setAttributeNS(null,"x", x + 430);
    column4.setAttributeNS(null,"y", y);
    column4.setAttributeNS(null,"font-size", fontSize);
    column4.setAttributeNS(null,"fill", textColor);

    var content4 = document.createTextNode(`${val4}`);
    column4.appendChild(content4)

    let column5 = document.createElementNS(xmlns, "text");
    column5.setAttributeNS(null,"font-family", fontFamily);
    column5.setAttributeNS(null,"x", x + 543);
    column5.setAttributeNS(null,"y", y);
    column5.setAttributeNS(null,"font-size", fontSize);
    column5.setAttributeNS(null,"fill", textColor);

    var content5 = document.createTextNode(`${val5}`);
    column5.appendChild(content5)



    tableHeaderContainer.appendChild(model)
    tableHeaderContainer.appendChild(column1)
    tableHeaderContainer.appendChild(column2)
    tableHeaderContainer.appendChild(column3)
    tableHeaderContainer.appendChild(column4)
    tableHeaderContainer.appendChild(column5)

    return tableHeaderContainer
}

const getLocaleDateString = () => {
    var formats = { "ar-SA": "DD/MM/YY", "bg-BG": "DD.MM.YYYY", "ca-ES": "DD/MM/YYYY", "zh-TW": "YYYY/MM/DD", "cs-CZ": "DD.MM.YYYY", "da-DK": "DD-MM-YYYY", "de-DE": "DD.MM.YYYY", "el-GR": "DD/MM/YYYY", "en": "MM/DD/YYYY", "en-US": "MM/DD/YYYY", "fi-FI": "DD.MM.YYYY", "fr-FR": "DD/MM/YYYY", "he-IL": "DD/MM/YYYY", "hu-HU": "YYYY. MM. DD.", "is-IS": "DD.MM.YYYY", "it-IT": "DD/MM/YYYY", "ja-JP": "YYYY/MM/DD", "ko-KR": "YYYY-MM-DD", "nl-NL": "DD-MM-YYYY", "nb-NO": "DD.MM.YYYY", "pl-PL": "YYYY-MM-DD", "pt-BR": "DD/MM/YYYY", "ro": "DD.MM.YYYY", "ro-RO": "DD.MM.YYYY", "ru-RU": "DD.MM.YYYY", "hr-HR": "DD.MM.YYYY", "sk-SK": "DD. MM. YYYY", "sq-AL": "YYYY-MM-DD", "sv-SE": "YYYY-MM-DD", "th-TH": "DD/MM/YYYY", "tr-TR": "DD.MM.YYYY", "ur-PK": "DD/MM/YYYY", "id-ID": "DD/MM/YYYY", "uk-UA": "DD.MM.YYYY", "be-BY": "DD.MM.YYYY", "sl-SI": "DD.MM.YYYY", "et-EE": "DD.MM.YYYY", "lv-LV": "YYYY.MM.DD.", "lt-LT": "YYYY.MM.DD", "fa-IR": "MM/DD/YYYY", "vi-VN": "DD/MM/YYYY", "hy-AM": "DD.MM.YYYY", "az-Latn-AZ": "DD.MM.YYYY", "eu-ES": "YYYY/MM/DD", "mk-MK": "DD.MM.YYYY", "af-ZA": "YYYY/MM/DD", "ka-GE": "DD.MM.YYYY", "fo-FO": "DD-MM-YYYY", "hi-IN": "DD-MM-YYYY", "ms-MY": "DD/MM/YYYY", "kk-KZ": "DD.MM.YYYY", "ky-KG": "DD.MM.YY", "sw-KE": "MM/DD/YYYY", "uz-Latn-UZ": "DD/MM YYYY", "tt-RU": "DD.MM.YYYY", "pa-IN": "DD-MM-YY", "gu-IN": "DD-MM-YY", "ta-IN": "DD-MM-YYYY", "te-IN": "DD-MM-YY", "kn-IN": "DD-MM-YY", "mr-IN": "DD-MM-YYYY", "sa-IN": "DD-MM-YYYY", "mn-MN": "YY.MM.DD", "gl-ES": "DD/MM/YY", "kok-IN": "DD-MM-YYYY", "syr-SY": "DD/MM/YYYY", "dv-MV": "DD/MM/YY", "ar-IQ": "DD/MM/YYYY", "zh-CN": "YYYY/MM/DD", "de-CH": "DD.MM.YYYY", "en-GB": "DD/MM/YYYY", "es-MX": "DD/MM/YYYY", "fr-BE": "DD/MM/YYYY", "it-CH": "DD.MM.YYYY", "nl-BE": "DD/MM/YYYY", "nn-NO": "DD.MM.YYYY", "pt-PT": "DD-MM-YYYY", "sr-Latn-CS": "DD.MM.YYYY", "sv-FI": "DD.MM.YYYY", "az-Cyrl-AZ": "DD.MM.YYYY", "ms-BN": "DD/MM/YYYY", "uz-Cyrl-UZ": "DD.MM.YYYY", "ar-EG": "DD/MM/YYYY", "zh-HK": "DD/MM/YYYY", "de-AT": "DD.MM.YYYY", "en-AU": "DD/MM/YYYY", "es-ES": "DD/MM/YYYY", "fr-CA": "YYYY-MM-DD", "sr-Cyrl-CS": "DD.MM.YYYY", "ar-LY": "DD/MM/YYYY", "zh-SG": "DD/MM/YYYY", "de-LU": "DD.MM.YYYY", "en-CA": "DD/MM/YYYY", "es-GT": "DD/MM/YYYY", "fr-CH": "DD.MM.YYYY", "ar-DZ": "DD-MM-YYYY", "zh-MO": "DD/MM/YYYY", "de-LI": "DD.MM.YYYY", "en-NZ": "DD/MM/YYYY", "es-CR": "DD/MM/YYYY", "fr-LU": "DD/MM/YYYY", "ar-MA": "DD-MM-YYYY", "en-IE": "DD/MM/YYYY", "es-PA": "MM/DD/YYYY", "fr-MC": "DD/MM/YYYY", "ar-TN": "DD-MM-YYYY", "en-ZA": "YYYY/MM/DD", "es-DO": "DD/MM/YYYY", "ar-OM": "DD/MM/YYYY", "en-JM": "DD/MM/YYYY", "es-VE": "DD/MM/YYYY", "ar-YE": "DD/MM/YYYY", "en-029": "MM/DD/YYYY", "es-CO": "DD/MM/YYYY", "ar-SY": "DD/MM/YYYY", "en-BZ": "DD/MM/YYYY", "es-PE": "DD/MM/YYYY", "ar-JO": "DD/MM/YYYY", "en-TT": "DD/MM/YYYY", "es-AR": "DD/MM/YYYY", "ar-LB": "DD/MM/YYYY", "en-ZW": "MM/DD/YYYY", "es-EC": "DD/MM/YYYY", "ar-KW": "DD/MM/YYYY", "en-PH": "MM/DD/YYYY", "es-CL": "DD-MM-YYYY", "ar-AE": "DD/MM/YYYY", "es-UY": "DD/MM/YYYY", "ar-BH": "DD/MM/YYYY", "es-PY": "DD/MM/YYYY", "ar-QA": "DD/MM/YYYY", "es-BO": "DD/MM/YYYY", "es-SV": "DD/MM/YYYY", "es-HN": "DD/MM/YYYY", "es-NI": "DD/MM/YYYY", "es-PR": "DD/MM/YYYY", "am-ET": "DD/MM/YYYY", "tzm-Latn-DZ": "DD-MM-YYYY", "iu-Latn-CA": "DD/MM/YYYY", "sma-NO": "DD.MM.YYYY", "mn-Mong-CN": "YYYY/MM/DD", "gd-GB": "DD/MM/YYYY", "en-MY": "DD/MM/YYYY", "prs-AF": "DD/MM/YY", "bn-BD": "DD-MM-YY", "wo-SN": "DD/MM/YYYY", "rw-RW": "MM/DD/YYYY", "qut-GT": "DD/MM/YYYY", "sah-RU": "MM.DD.YYYY", "gsw-FR": "DD/MM/YYYY", "co-FR": "DD/MM/YYYY", "oc-FR": "DD/MM/YYYY", "mi-NZ": "DD/MM/YYYY", "ga-IE": "DD/MM/YYYY", "se-SE": "YYYY-MM-DD", "br-FR": "DD/MM/YYYY", "smn-FI": "DD.MM.YYYY", "moh-CA": "MM/DD/YYYY", "arn-CL": "DD-MM-YYYY", "ii-CN": "YYYY/mM/DD", "dsb-DE": "DD. MM. YYYY", "ig-NG": "DD/MM/YYYY", "kl-GL": "DD-MM-YYYY", "lb-LU": "DD/MM/YYYY", "ba-RU": "DD.MM.YY", "nso-ZA": "YYYY/MM/DD", "quz-BO": "DD/MM/YYYY", "yo-NG": "DD/MM/YYYY", "ha-Latn-NG": "DD/MM/YYYY", "fil-PH": "MM/DD/YYYY", "ps-AF": "DD/MM/YY", "fy-NL": "DD-MM-YYYY", "ne-NP": "MM/DD/YYYY", "se-NO": "DD.MM.YYYY", "iu-Cans-CA": "DD/MM/YYYY", "sr-Latn-RS": "DD.MM.YYYY", "si-LK": "YYYY-MM-DD", "sr-Cyrl-RS": "DD.MM.YYYY", "lo-LA": "DD/MM/YYYY", "km-KH": "YYYY-MM-DD", "cy-GB": "DD/MM/YYYY", "bo-CN": "YYYY/MM/DD", "sms-FI": "DD.MM.YYYY", "as-IN": "DD-MM-YYYY", "ml-IN": "DD-MM-YY", "en-IN": "DD-MM-YYYY", "or-IN": "DD-MM-YY", "bn-IN": "DD-MM-YY", "tk-TM": "DD.MM.YY", "bs-Latn-BA": "DD.MM.YYYY", "mt-MT": "DD/MM/YYYY", "sr-Cyrl-ME": "DD.MM.YYYY", "se-FI": "DD.MM.YYYY", "zu-ZA": "YYYY/MM/DD", "xh-ZA": "YYYY/MM/DD", "tn-ZA": "YYYY/MM/DD", "hsb-DE": "DD. MM. YYYY", "bs-Cyrl-BA": "DD.MM.YYYY", "tg-Cyrl-TJ": "DD.MM.YY", "sr-Latn-BA": "DD.MM.YYYY", "smj-NO": "DD.MM.YYYY", "rm-CH": "DD/MM/YYYY", "smj-SE": "YYYY-MM-DD", "quz-EC": "DD/MM/YYYY", "quz-PE": "DD/MM/YYYY", "hr-BA": "DD.MM.YYYY.", "sr-Latn-ME": "DD.MM.YYYY", "sma-SE": "YYYY-MM-DD", "en-SG": "DD/MM/YYYY", "ug-CN": "YYYY-MM-DD", "sr-Cyrl-BA": "DD.MM.YYYY", "es-US": "MM/DD/YYYY" }
    return formats[navigator.language] ||  'DD/MM/YYYY';
  }

export default {
    prepareForExport,
    drawLabels,
    getIdealAspectRatio,
    formatGraph,
    formatTable,
    createGraphHeader,
    createFooter,
    createHeaderNodesSVG,
    createHeaderContentSVG,
    createHeaderLine,
    createSvgContainer,
    generateSvgGraph,
    createGraphLocationNode,
    createString,
    createBreastRiskTable,
    createChartHeader,
    createTableLine,
    createTableHeader,
    createTableRow,
    createOvarianTable,
    createColonTable,
    createUterineTable,
    createPancTable,
    createMelanomaTable,
    createMutationTable1,
    createMutationTable2,
    createMutationTableHeader,
    createMutationTableLine,
    createMutationTable2Header,
    createMutationRow,
    getLocaleDateString
}